import React, { useState } from 'react';
import './App.scss';
import Editor from './Editor.js';
import Preview from './Preview.js';

function App() {
  
  let placeholder = `# Welcome to my React Markdown Previewer!

## This is a sub-heading...
### And here's some other cool stuff:

Heres some code, \`<div></div>\`, between 2 backticks.

\`\`\`
// this is multi-line code:

function anotherExample(firstLine, lastLine) {
  if (firstLine == '\`\`\`' && lastLine == '\`\`\`') {
    return multiLineCode;
  }
}
\`\`\`

You can also make text **bold**... whoa!
Or _italic_.
Or... wait for it... **_both!_**
And feel free to go crazy ~~crossing stuff out~~.

There's also [links](https://www.freecodecamp.com), and
> Block Quotes!

And if you want to get really crazy, even tables:

Wild Header | Crazy Header | Another Header?
------------ | ------------- | -------------
Your content can | be here, and it | can be here....
And here. | Okay. | I think we get it.

- And of course there are lists.
  - Some are bulleted.
     - With different indentation levels.
        - That look like this.


1. And there are numbererd lists too.
1. Use just 1s if you want!
1. And last but not least, let's not forget embedded images:

![React Logo w/ Text](https://goo.gl/Umyytc)
`
  const [rawInput, setInput] = useState(placeholder);

  return (
    <div className="App row" id="wrapper">
      <div className="col editor mt-3 text-center">
        EDITOR<br/>
      <Editor placeholder={rawInput} setInput={setInput}/>
      </div>
      <div className="col mt-3 text-center">
        PREVIEW
      <Preview rawInput={rawInput}/>
      </div>
    </div>
  );
}

export default App;
